import React, { Component } from 'react';
import { marketApi } from './BotMarketPanel';
import '.././css/style.css';

export default class BotListPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            botlist: [],
            needreply: [],
            bot: null,
            loading: false,
            mode: props.mode,
            botSelected: null,
            searchKeyword: ""
        }
        this.getActiveBOT = this.getActiveBOT.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
    }

    getActiveBOT() {
        this.setState({ loading: true, error: '' });
        marketApi('/overview', {market: this.props.market || 'VN'})
            .then(data => this.setState({botlist: data.bots, loading: false}))
            .catch(error => this.setState({loading: false, error: error.message}));
    }

    handleBotClick(param) {
        // Gọi hàm từ props và truyền param nếu cần
        this.props.onBotClick(param);
        this.setState({
            botSelected: param
        })
    }

    componentDidMount() {
        this.getActiveBOT();
    }

    handleSearchChange(event) {
        this.setState({ searchKeyword: event.target.value });
    }

    clearSearch() {
        this.setState({ searchKeyword: "" });
    }

    filterBotList() {
        const { botlist, searchKeyword } = this.state;
        const keyword = searchKeyword.trim().toLowerCase();
        if (!keyword) return botlist;
        return botlist.filter(item => {
            const uid = String(item.uid || "").toLowerCase();
            const name = String(item.name || "").toLowerCase();
            return uid.includes(keyword) || name.includes(keyword);
        });
    }

    renderSkeleton() {
        return (
            <div className="botlist-skeleton">
                {[...Array(6)].map((_, index) => (
                    <div className="botlist-skeleton-item" key={index}>
                        <div className="botlist-skeleton-avatar"></div>
                        <div className="botlist-skeleton-lines">
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    renderEmptyState() {
        return (
            <div className="botlist-empty">
                <i className="fa-regular fa-circle-question"></i>
                <p>Không tìm thấy BOT phù hợp</p>
                <span>Hãy thử đổi từ khóa tìm kiếm.</span>
            </div>
        );
    }

    render() {
        const { botlist, botSelected, loading, searchKeyword } = this.state;
        const { standalone = true } = this.props;
        const filteredBots = this.filterBotList();
        const content = (
            <div className="botlist-content">
                <div className="botlist-search-row">
                    <div className="botlist-search">
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input
                            type="text"
                            placeholder="Tìm kiếm"
                            value={searchKeyword}
                            onChange={this.handleSearchChange}
                        />
                        {searchKeyword && (
                            <button className="botlist-clear" onClick={this.clearSearch}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        )}
                    </div>
                    <button
                        className="botlist-refresh"
                        onClick={this.getActiveBOT}
                        disabled={loading}
                    >
                        <i className={`fa-solid fa-rotate ${loading ? 'fa-spin' : ''}`}></i>
                        Làm mới
                    </button>
                </div>
                {this.state.error && <p role="alert">{this.state.error}</p>}
                <div className="botlist-scroll">
                    {loading ? (
                        this.renderSkeleton()
                    ) : filteredBots.length === 0 ? (
                        this.renderEmptyState()
                    ) : (
                        filteredBots.map(item => (
                            <button
                                key={item.id}
                                className={`bot-card ${item.id == botSelected ? 'active' : ''}`}
                                onClick={() => this.handleBotClick(item.id)}
                            >
                                <div className="bot-card-info">
                                    <span className="bot-card-uid">{item.uid}</span>
                                    <strong className="bot-card-name">{item.name}</strong>
                                </div>
                                <div className="bot-card-avatar">
                                    <img src={item.avatar} alt="avatar" className="avatar" />
                                </div>
                            </button>
                        ))
                    )}
                </div>
            </div>
        );

        return (
            <>
                {standalone ? (
                    <div className="botlist-panel">
                        {content}
                    </div>
                ) : content}
            </>
        );
    }
}

